import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
const replyDefaults = {
  id: null,
  repliedAt: null,
  reply: null,
  replierDisplayName: null,
  avatarUrl: null,
  companyName: null
};
export default class Reply extends createImmutableObjectClass(replyDefaults) {}